<template>
  <div class="tab_a">
    <div>
      <el-checkbox-group v-model="checkList" @change="ChanegeCheckGroup">
        <el-checkbox label="1">全选男童上装</el-checkbox>
        <el-checkbox label="2">全选女童上装</el-checkbox>
        <el-checkbox label="3">全选男童下装</el-checkbox>
        <el-checkbox label="4">全选女童下装</el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="Size_box">
      <table border="0" cellspacing="0" class="hcp_table">
        <thead>
          <tr>
            <th rowspan="2">身高(cm)</th>
            <th colspan="2">男童</th>
            <th colspan="2">女童</th>
          </tr>
          <tr>
            <th>上装</th>
            <th>下装</th>
            <th>上装</th>
            <th>下装</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,key,index) in DataList" :key="index">
          <td class="size_cm">{{key}}</td>
          <td>
            <div v-for="(x,ind) in item.UP" :key="ind" :class="{'ts_size_box':x.modelExtendCode=== 'BOY'}">
                <span v-if="x.modelExtendCode=== 'BOY'" @click="ChangeSize(x)"
                      :class="{'active_size':filterSizeActive(x),'size_child':true,'size_last_child':ind===2}">
                  {{x.typeValue}}
                </span>
            </div>
          </td>
          <td>
            <div v-for="(x,ind) in item.DOWN" :key="ind" :class="{'ts_size_box':x.modelExtendCode=== 'BOY'}">
                <span v-if="x.modelExtendCode=== 'BOY'" @click="ChangeSize(x)" :class="{'active_size':filterSizeActive(x),'size_child':true,'size_last_child':ind===2}">
                  {{x.typeValue}}
                </span>
            </div>
          </td>
          <td>
            <div v-for="(x,ind) in item.UP" :key="ind"  :class="{'ts_size_box':x.modelExtendCode=== 'GIRL'}">
                <span v-if="sub(item.DOWN)" class="size_child size_child_div"></span>
                <span v-if="x.modelExtendCode=== 'GIRL'" @click="ChangeSize(x)"  :class="{'active_size':filterSizeActive(x),'size_child':true,'size_last_child':ind===5}" >
                  {{x.typeValue}}
                </span>
            </div>
          </td>
          <td>
            <div v-for="(x,ind) in item.DOWN" :key="ind" :class="{'ts_size_box':x.modelExtendCode=== 'GIRL'}">
                <span v-if="sub(item.DOWN)" class="size_child size_child_div"></span>
                <span v-if="x.modelExtendCode=== 'GIRL'" @click="ChangeSize(x)" :class="{'active_size':filterSizeActive(x),'size_child':true,'size_last_child':ind===5}" >
                  {{x.typeValue}}
                </span>
            </div>
          </td>
        </tr>
        </tbody>

      </table>
    </div>
  </div>
</template>

<script>
import SizeMixins from './mixin'
export default {
  name: "BoysAndGirls",
  mixins:[SizeMixins],
  props:{
    DataList:{
      type: Object,
      default: ()=>{}
    },
  },
  data(){
    return {
      checkList:[]
    }
  },
  mounted() {
    this.EchoSizeData('BoysAndGirls')
    console.log(this.DataList)
  },
  created() {
  },
  methods:{
    sub(list){
      let i =0
      list.forEach(item=>{
        if(item.modelExtendCode=== 'GIRL'&& item.typeMainCode==="DOWN"){
          i++
        }
      })
      if(i===0){
        return true
      }
    },
    ChangeSize(x){
      if(x.typeId) {
        this.StorageSizeData(x, 'BoysAndGirls')
      }
    },
    ChanegeCheckGroup(val){
      this.SelectAllSizeBoyAndGirl(val,'BoysAndGirls')
    }
  }
}
</script>

<style scoped lang="scss">
table {
  border: none;
  padding: 0;
  margin:0;
}
tr,td{
  padding: 0;
  margin:0;
}
table tbody{
  display: block;
  height: 300px;
  overflow-y: auto;
  text-align: center;
  -webkit-overflow-scrolling: touch;
}
table thead,
tbody tr{
  display: table;
  width: 100%;
  table-layout: fixed;
}
.Size_box{
  margin-top: 10px;
  width: 850px;
  .hcp_table{
    border-spacing: 0;
    border: 1px solid #cccccc;
    background:rgb(246,246,246);
    thead{
      width: calc(100% - 17px);
    }
    tbody tr:last-child td{
      border-bottom: none;
    }
    tbody tr td:last-child{
      border-right: none;
    }
    tr{
      background: #FFFFFF;
    }
    th{
      background: #F6F6F6;
      font-size: 14px;
    }
    td{
      cursor: pointer;
      vertical-align: top;
      font-size: 14px;
      div:last-child .size_child_div{
          border-bottom: none;
      }
      .size_last_child{
        border-bottom: none !important;
      }
    }
    tbody tr td .ts_size_box:last-child .size_child{
      //border-bottom: none;
    }
    tr{
      .size_child{
        height: 45px;
        line-height: 45px;
        border-bottom: 1px solid #ccc;
        display: block;
      }
      .size_cm{
        vertical-align: middle;
      }
    }
    th,td{
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      text-align: center;
      min-width: 120px;
      height: 45px;
    }
  }
}
.active_size{
  background-color: #FAECE6;
  color: #000000;
}

</style>